import React from "react";

import { Script } from "gatsby";

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation && !location.hash) {
    // do not restore scroll position on page refresh without hash
    setTimeout(
      () => window.scrollTo({ top: 0, left: 0, behavior: "instant" }),
      0,
    );
  }
};

export const wrapPageElement = ({ element }) => (
  <>
    {element}

    <Script
      src="https://kit.fontawesome.com/297f7cef0e.js"
      crossOrigin="anonymous"
    />
  </>
);
